<template>
	
	<div>
		
		<layout>

			<template v-slot:title> 
				TÉRMINOS Y PRIVACIDAD
			</template>

			<template v-slot:subtitle> 
				TÉRMINOS Y PRIVACIDAD
			</template>

			<template v-slot:content>

				<v-container id="gnral-setting">


					<v-row class="mt-4 mb-4">
						<v-col offset-lg="1" lg="10">

							<form @submit.prevent="update()">
								
								<v-card light class="pa-5" elevation="3">

									<div>
										<h4 class="mb-4">Términos y Condiciones</h4>
										<div id="terms-content" style="min-height: 400px;"></div>
									</div>

									<div class="mt-10">
										<h4 class="mb-4">Política de Privacidad</h4>
										<div id="privacy-content" style="min-height: 400px;"></div>
									</div>

		      	      <v-btn class="mt-10" dark large block type="submit">
		      		      Actualizar
		      		    </v-btn>

								</v-card>

							</form>

						</v-col>
					</v-row>
				</v-container>

			</template>

		</layout>
		

	</div>

</template>


<style src="./quill.snow.css"></style>


<script>
	
	import Layout from './../../layout/Layout'
	import TermsService from '@/shared/services/TermsService'

	import { loadScript } from "vue-plugin-load-script"


	export default 
	{
		
		data() {
			return {
				terms: {
					terms: null,
					privacy: null,
				}
			}
		},

		components: {
			Layout
		},

		mounted() {
			this.get();
		},

		methods: {

			async get()
			{
				// init editor
				let url = 'https://cdn.quilljs.com/1.3.6/quill.js'
				await loadScript(url)

				let options = {
				  modules: {
				    toolbar: [
				    	[{ 'header': [1, 2, 3, 4, 5, 6, false] }],

				    	['bold', 'italic', 'underline', 'strike'],  

				    	[{ 'align': [] }],

				    	[{ 'indent': '-1'}, { 'indent': '+1' }],

				    	[{ 'color': [] }, { 'background': [] }],

				    	['link'],
						                     
						  ['clean'] 
				    ]
				  },
				  theme: 'snow'
				};


				let editorTerms = new Quill('#terms-content', options);
				let editorPrivacy = new Quill('#privacy-content', options);



				const resp = await TermsService.get()

				this.terms.terms = resp.data.terms
				this.terms.privacy = resp.data.privacy


				setTimeout(()=> 
				{
					if(this.terms.terms != "undefined")
					{
						$('#terms-content .ql-editor').html(this.terms.terms)
						$('#privacy-content .ql-editor').html(this.terms.privacy)
					}
				}, 500)
			},


			async update()
			{
				this.terms.terms = $('#terms-content .ql-editor').html()
				this.terms.privacy = $('#privacy-content .ql-editor').html()


    		const resp = await TermsService.update(this.terms)

    		if(resp.data == 'OK')
    			SwalAlert('', 'Datos actualizados', 'success')
    		else
    			SwalAlert('', 'Ha ocurrido un error, por favor intenta de nuevo')
			}

		}

	}

</script>